import BaseComponent from 'scripts/BaseComponent.js';

export default class TwoColumn extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      link: '.js-link',
      container: '.js-container',
    };

    this.dom = {
      $component: component,
      $containers: this.$getAll(this.refs.container),
    };

    this.state = {};

    this.mount();
  }

  mount() {
    const { dom } = this;
    this.setClickWithElement(dom.$containers, this.clickHandler);
  }

  clickHandler(element) {
    const link = element.querySelector(this.refs.link).href;
    window.location.href = link;
  }
}
